import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebaseConfig';

/**
 * Sends a message to Firestore following the specified structure
 * @param {string} uid - User ID
 * @param {string} platformNumber - Platform's phone number (e.g. "+14159185883")
 * @param {string} otherNumber - Recipient's phone number (e.g. "+14159998941")
 * @param {string} textMessage - Message content
 * @param {function} setTextMessage - Function to clear input
 * @param {Array<string>} mediaUrls - Optional array of media URLs for MMS
 * @returns {Promise<void>}
 */
const sendMessageToFirestore = async (uid, platformNumber, otherNumber, textMessage, setTextMessage, mediaUrls = []) => {
  try {
    // Generate a UUID for the message
    const messageId = crypto.randomUUID();
    
    // Construct the exact Firestore path as specified
    const conversationId = `${platformNumber}_${otherNumber}`;
    const messagePath = `messagingplatform/${uid}/conversations/${conversationId}/messages/${messageId}`;
    
    // Create the message document with exactly the specified fields
    const messageData = {
      body: textMessage,
      direction: 'outbound',
      timestamp: serverTimestamp(),
      status: null,
      metadata: {}
    };
    
    // Add media URLs if provided (for MMS support)
    if (mediaUrls && mediaUrls.length > 0) {
      messageData.mediaUrls = mediaUrls;
    }
    
    await setDoc(doc(db, messagePath), messageData);
    
    console.log(`Message sent to Firestore at path: ${messagePath}`, 
      mediaUrls.length > 0 ? `with ${mediaUrls.length} media attachments` : '');
    
    // Clear the input after successful write
    setTextMessage('');
  } catch (error) {
    console.error('Error sending message to Firestore:', error);
    throw error;
  }
};

export default sendMessageToFirestore; 